/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { AirplaneBookingList as AirplaneBookingListMole } from "../../molecules";
import { AirplaneBookingWrapper } from "./AirplaneBooking.style";
import { AirplaneBookingListToolbar } from "./AirplaneBookingListToolbar";

export const AirplaneBookingList: React.FC = () => {
  const { bookingAirplanes } = useSelector((state: any) => state.bookings);
  const { loading } = useSelector((state: any) => state.async);
  const [searchBookingId, setSearchBookingId] = React.useState("");
  const filteredBookings = React.useMemo(() => {
    const query = searchBookingId.trim().toLowerCase();
    if (!query) return bookingAirplanes;
    return bookingAirplanes.filter((booking: any) =>
      String(booking.bookingId || "")
        .toLowerCase()
        .includes(query)
    );
  }, [bookingAirplanes, searchBookingId]);
  return (
    <AdminPageBody
      pageToolbar={
        <AirplaneBookingListToolbar
          searchBookingId={searchBookingId}
          onSearchBookingIdChange={setSearchBookingId}
        />
      }
    >
      <AirplaneBookingWrapper>
        <AirplaneBookingListMole
          bookings={filteredBookings}
          loading={loading}
        />
      </AirplaneBookingWrapper>
    </AdminPageBody>
  );
};
